import { useState } from 'react'
import { ICostAndQuantity, IITemToPurchase, IRotationForm } from 'safe'
import { IItem } from '../../../common/Inventory/Items'
import CostForm from '../../Inventory/CostForm'
import RotationForm from '../../Inventory/RotationForm'

const StepForm: React.FC<StepFormProps> = ({
  item,
  itemToPurchase,
  onClose,
  loadMethod,
  disableQuantities = false,
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [costAndPrice, setCostAndPrice] = useState<ICostAndQuantity | null>(
    () => {
      if (itemToPurchase) {
        const costAndPrice: ICostAndQuantity = {
          id_item: itemToPurchase.id,
          quantity: itemToPurchase.quantity,
          loaded_quantity: itemToPurchase.loaded_quantity,
          missing: itemToPurchase.missing,
          cost: itemToPurchase.cost,
          price: itemToPurchase.price,
          total: itemToPurchase.total,
          calc_unit_cost: itemToPurchase.calc_unit_cost,
          prev_cost: itemToPurchase.prev_cost,
        }
        return costAndPrice
      }
      return null
    }
  )

  const rotation: IRotationForm = itemToPurchase ? {
    id_item: itemToPurchase.id,
    creation_date: itemToPurchase.creation_date,
    expiration_date: itemToPurchase.expiration_date,
    rotation_date: itemToPurchase.rotation_date,
    batch: itemToPurchase.batch,
  }
    :
    item?.batch[0]


  const tabs = ['Costos', 'Rotación']

  const handleSubmit = (rotation: IRotationForm) => {
    loadMethod(item, costAndPrice, rotation)
    onClose()
  }

  return (
    <div className="m-auto">
      <div className="flex flex-nowrap rounded-lg bg-gray-100 divide-x-2 divide-gray-200 dark:bg-gray-800 m-auto mb-10">
        {tabs.map((tab, i) => (
          <div
            key={tab}
            className={`px-3 flex-grow transition-all py-2.5 flex items-center justify-center ${selectedTab === i
              ? 'bg-white dark:bg-gray-600'
              : 'dark:bg-gray-900'
              }`}
          >
            <div className={`h-full flex items-center`}>
              <span className="text-center">
                {/* <Icon
              className={`${
                i === selected
                ? 'text-primary dark:text-white'
                : 'text-trueGray-600 dark:text-gray-300'
              } mr-3 z-20 text-lg`}
            /> */}
              </span>
              <p
                className={`${selectedTab === i
                  ? 'text-primary dark:text-white'
                  : 'text-trueGray-600 dark:text-gray-300'
                  }`}
              >
                <b>{tab}</b>
              </p>
            </div>
          </div>
        ))}
      </div>
      {selectedTab === 0 && (
        <CostForm
          cost={
            costAndPrice?.cost ||
            (item?.cost?.length > 0 ? item?.cost[0]?.amount : '0.00')
          }
          price={
            costAndPrice?.price ||
            (item?.price?.length > 0 ? item.price[0]?.amount : '0.00')
          }
          quantity={costAndPrice?.quantity}
          loaded_quantity={costAndPrice?.loaded_quantity}
          missing={costAndPrice?.missing}
          total={costAndPrice?.total}
          calc_unit_cost={costAndPrice?.calc_unit_cost}
          prev_cost={costAndPrice?.prev_cost}
          excent={item?.exempt}
          id_selected={item?.id}
          items={
            item?.type === 'COMPOUND'
              ? item.composition
              : item.type === 'ASSEMBLY'
                ? item.assembly
                : []
          }
          name={item?.name && item.name}
          itemType={item?.type}
          onClose={onClose}
          submitText="Siguiente"
          // getItems={() => dispatch(fetchItemsCall())}
          onPurchase={(costs: ICostAndQuantity) => {
            setSelectedTab(1)
            setCostAndPrice(costs)
          }}
          disableQuantities={disableQuantities}
        ></CostForm>
      )}
      {selectedTab === 1 && (
        <RotationForm
          id_item={item.id}
          batchProp={rotation}
          onClose={() => setSelectedTab(0)}
          submitText="Cargar"
          hasTitle={false}
          onPurchase={(newRotation: IRotationForm) => {
            handleSubmit(newRotation)
          }}
          cancelText="Atrás"
        />
      )}
    </div>
  )
}

export default StepForm

interface StepFormProps {
  item: IItem
  itemToPurchase?: IITemToPurchase | null
  onClose: Function
  loadMethod: Function
  disableQuantities?: boolean
}
